import "core-js/modules/es.reflect.construct.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
var _class, _class2;
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import BaseAdapter from '../base/BaseAdapter';
import { addQuery, getDetailUrl, jsticket, getWxPublicId, wxAuth, getShareMessage, getDomain, loadJS, isMiniprogram, guid } from '../../core/utils';
import { beforeLogin } from '../base/LoginAdapter';
// 微信浏览器，非微信小程序中
var WechatAdapter = (_class = (_class2 = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(WechatAdapter, _BaseAdapter);
  var _super = _createSuper(WechatAdapter);
  function WechatAdapter(_native) {
    var _this;
    _classCallCheck(this, WechatAdapter);
    var callbackName = "wxJsCallback".concat(guid());
    window[callbackName] = function (data) {
      var respData = data.respData;
      _this.jsticket = respData || {};
    };
    var wxPublicId = getWxPublicId();
    _this = _super.call(this, _native, ['https://s1.zhuanstatic.com/common/jweixin-1.5.0.js', jsticket(wxPublicId, callbackName)], function () {
      var conf = _this.jsticket || {};
      wxAuth(conf, _native.config);
    });
    _this.wxPublicId = wxPublicId;
    return _this;
  }
  _createClass(WechatAdapter, [{
    key: "initWxConfig",
    value: function initWxConfig(cb) {
      var _this2 = this;
      var callbackName = "wxJsCallback".concat(guid());
      loadJS(jsticket(this.wxPublicId, callbackName));
      window[callbackName] = function (data) {
        var respData = data.respData;
        var conf = respData || {};
        wxAuth(conf, _this2["native"].config);
        window.wx.ready(function () {
          cb && cb();
        });
      };
    }
  }, {
    key: "share",
    value: function share(shareMessage, callback, userConfigList) {
      var _configList = ['onMenuShareTimeline',
      // 朋友圈
      'onMenuShareAppMessage',
      // 好友
      'onMenuShareQQ',
      // qq
      'onMenuShareQZone',
      // qq 空间
      'onMenuShareWeibo' // 腾讯微博
      ];

      if (userConfigList !== null && userConfigList !== void 0 && userConfigList.length) {
        userConfigList.forEach(function (item) {
          if (!_configList.includes(item)) {
            console.warn(['adapter: native.share'], "".concat(item, " \u914D\u7F6E\u6709\u8BEF, \u53C2\u8003\u914D\u7F6E\uFF1A").concat(JSON.stringify(_configList)));
          }
        });
        _configList = userConfigList;
      }
      window.wx && window.wx.ready(function () {
        _configList.forEach(function (item) {
          var param = {};
          Object.assign(param, getShareMessage(shareMessage), {
            success: callback
          });
          window.wx[item](param);
        });
      });
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail(obj) {
      var _this3 = this;
      var infoId = obj.infoId,
        isTrade = obj.isTrade,
        _obj$metric = obj.metric,
        metric = _obj$metric === void 0 ? '' : _obj$metric,
        _obj$extraParam = obj.extraParam,
        extraParam = _obj$extraParam === void 0 ? {} : _obj$extraParam,
        _obj$needClose = obj.needClose,
        needClose = _obj$needClose === void 0 ? '0' : _obj$needClose;
      var extParam = '';
      try {
        extParam = encodeURIComponent(JSON.stringify(extraParam));
      } catch (error) {
        console.error('[adapter - skipToDetail] extraParam 参数解析异常');
      }
      obj.$customUrl = "".concat(getDomain(), "/platform/zzmshare/index.html?isTrade=").concat(isTrade ? 1 : 0, "&metric=").concat(metric, "&zzfrom=").concat(metric, "#/detail/").concat(infoId);
      var defaultUrl = getDetailUrl(obj);
      var cbName = "getCoodsDetailDataCb".concat(guid());
      window[cbName] = function (data) {
        var respCode = data.respCode,
          respData = data.respData;
        if (respCode == 0) defaultUrl = respData.webUrl || defaultUrl;
        if (/58\.com/.test(location.href)) defaultUrl = defaultUrl.replace('//m.zhuanzhuan.com', '//m.zhuanzhuan.58.com');
        // defaultUrl = `//app.zhuanzhuan.com/activity/comm/shouQuan?callbackUrl=${encodeURIComponent(defaultUrl)}`
        _this3.agentSkipToDetail(obj, function () {
          _this3.skipToUrl({
            targetUrl: defaultUrl,
            needClose: needClose
          });
        });
      };
      loadJS("https://app.zhuanzhuan.com/zz/transfer/getgoodsdetaildataexclusive?infoId=".concat(infoId, "&metric=").concat(metric, "&callback=").concat(cbName, "&extraparam=").concat(extParam), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "login",
    value: function login(params) {
      // 微信登录逻辑
      var targetUrl = ''; // 授权后跳转的目标url
      var zz_bid = 0; // 业务特殊表示id
      var url = ''; // 后端接口
      // 如果参数是对象，则对各个属性赋值
      if (_typeof(params) == 'object') {
        var _ref = [params.targetUrl, params.zz_bid];
        targetUrl = _ref[0];
        zz_bid = _ref[1];
      }
      targetUrl = addQuery(targetUrl || location.href, {
        __wx: new Date().getTime()
      });
      var domain = /caihuoxia\.com/.test(targetUrl) ? 'https://z.zone/nHWqd' : 'https://z.zone/xBk2';
      var appId = this.jsticket ? this.jsticket.appId || 'wx6685f78a0b7c4d0e' : 'wx6685f78a0b7c4d0e';
      // 如果是转转公众号
      if (appId === 'wx6685f78a0b7c4d0e') {
        url = "".concat(domain, "?state=&rurl=").concat(encodeURIComponent(targetUrl));
        // 不是转转公众号
      } else {
        var source = zz_bid || this.wxPublicId;
        url = "https://i.zhuanzhuan.com/3YgUz?source=".concat(source, "&state=&rurl=").concat(encodeURIComponent(targetUrl));
      }
      window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=".concat(appId, "&redirect_uri=").concat(encodeURIComponent(url), "&response_type=code&scope=snsapi_userinfo#wechat_redirect"));
    }
  }, {
    key: "getQRCodeScan",
    value: function getQRCodeScan(obj) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      window.wx && window.wx.ready(function () {
        window.wx.scanQRCode({
          desc: obj.desc || 'scanQRCode desc',
          needResult: obj.needResult || 1,
          scanType: obj.scanType || ['qrCode', 'barCode'],
          success: function success(res) {
            return res.errMsg.includes('ok') && callback({
              code: 0,
              resultString: res.resultStr,
              resultStr: res.resultStr,
              // 兼容老版本的返回值
              msg: res.errMsg || ''
            });
          },
          error: function error(res) {
            return callback({
              code: -1,
              resultString: '',
              resultStr: '',
              // 兼容老版本的返回值
              msg: res.errMsg || ''
            });
          }
        });
      });
    }
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(params) {
      window.wx && window.wx.ready(function () {
        window.wx.openLocation({
          latitude: parseFloat(params.lat),
          // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(params.lon),
          // 经度，浮点数，范围为180 ~ -180。
          name: params.name,
          // 位置名
          address: params.address,
          // 地址详情说明
          scale: params.scale || 28 // 地图缩放级别,整形值,范围从1~28。默认为最大
        });
      });
    }
  }, {
    key: "close",
    value: function close() {
      window.wx.closeWindow();
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(callback) {
      window.wx && window.wx.ready(function () {
        window.wx.getLocation({
          type: 'gcj02',
          // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function success(res) {
            callback({
              code: '0',
              lon: res.longitude,
              lat: res.latitude
            });
          },
          fail: function fail() {
            callback({
              code: '-1'
            });
          }
        });
      });
    }
  }, {
    key: "enlargeImage",
    value: function enlargeImage(obj) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var urls = obj.imgUrls.split('|');
      var current = urls[obj.selectedIndex];
      window.wx && window.wx.ready(function () {
        window.wx.previewImage({
          urls: urls,
          current: current,
          complete: function complete(res) {
            return callback(res);
          }
        });
      });
    }
  }]);
  return WechatAdapter;
}(BaseAdapter), _class2.pluginName = 'WechatAdapter', _class2.platform = [{
  rule: function rule() {
    return /MicroMessenger/i.test(navigator.userAgent) && !isMiniprogram() && !/wxwork/i.test(navigator.userAgent);
  },
  name: 'wechat'
}], _class2), (_applyDecoratedDescriptor(_class.prototype, "login", [beforeLogin], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);
export { WechatAdapter as default };